import React from 'react';
import { AdminNavigation } from 'src/components';

const AdminLayout = ({ children }) => {
  return (
    <div className="w-full">
      <div className="grid grid-cols-6">
        <div className="col-span-2 sm:col-span-1">
          <AdminNavigation />
        </div>
        <div className="col-span-4 sm:col-span-5">{children}</div>
      </div>
    </div>
  );
};

export default AdminLayout;
